module.exports = __webpack_public_path__ + "static/media/rules_tree.50e69607.jpg";